// TODO: delete me if no longer used

// @ts-ignore
// import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry"
import * as pdfjs from "pdfjs-dist";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const DOCUMENT_FRAME_ATTRIBUTES = {
  IS_FACADE_VISIBLE: "isFacadeVisible",
  SRC: "src",
  IMAGE: "image"
};

function isMobileDevice() {
  return window.matchMedia("only screen and (max-width: 480px)").matches;
}

export class DocumentFrame extends HTMLElement {
  src: string;
  image: string;
  filetype: string | null;
  isFacadeVisible: boolean;
  page: number;

  readyPromise: Promise<void>;
  resolveReady: (value: void | PromiseLike<void>) => void;

  /**
   * List of attributes that when changed call `attributeChangedCallback`
   */
  static get observedAttributes() {
    return [
      DOCUMENT_FRAME_ATTRIBUTES.IS_FACADE_VISIBLE,
      DOCUMENT_FRAME_ATTRIBUTES.SRC
    ];
  }

  constructor() {
    super();

    console.log("lazy-iframe constructor");

    this.src = this.getAttribute("data-src") || "";
    this.image = this.getAttribute("data-image") || "";
    this.filetype = this.getAttribute("data-filetype");
    this.isFacadeVisible = isMobileDevice();
    this.page = 1;

    this.resolveReady = () => { };
    this.readyPromise = new Promise((resolve) => {
      this.resolveReady = resolve;
    });
  }

  /**
   * When this is connected to the DOM
   *
   * Triggered when the element has been attached to the regular DOM. We
   * can do important work after this point.
   */
  connectedCallback() {
    // We resolve this promise here so that code elsewhere knows when it
    // can operate on the DOM.
    console.log("lazy-iframe connected callback");

    this.baseRender();
    this.resolveReady();
  }

  baseRender() {
    const _this = this;

    let inner = "";

    if (this.image === "") {
      // if we have no image w/e
      inner = `<canvas class="rounded-sm mx-auto my-6 shadow max-h-full"></canvas>`;
    } else if (this.page === 1 && this.image !== "") {
      inner = `<img class="rounded-sm my-6 mx-auto shadow max-h-full" src="${this.image}"/>`;
    } else {
      inner = `<canvas class="rounded-sm mx-auto my-6 shadow max-h-full"></canvas>`;
    }

    this.innerHTML = `
      <div class="w-full flex flex-col gap-8 bg-neutral-50">
        <div class="mx-auto bg-neutral-100 px-12 h-[400px] sm:h-[800px]">
          ${inner}
        </div>

        <div class="flex gap-4 mx-auto mb-4">
          <button id="previous" class="rounded-md border-1 px-3 py-2 bg-white">
            Previous Page
          </button>

          <button id="next" class="rounded-md border-1 px-3 py-2 bg-white">
            Next Page
          </button>
        </div>
      </div>
      `;

    document
      .getElementById("previous")
      ?.addEventListener("click", (ev: MouseEvent) => {
        ev.preventDefault();
        console.log("previous");

        if (_this.page > 0) _this.page--;
        _this.baseRender();

        try {
          // @ts-ignore
          window.posthog.capture("PDF Page Click", {
            direction: "previous"
          });
        } catch (err) {
          console.log(err);
        }
      });

    document
      .getElementById("next")
      ?.addEventListener("click", (ev: MouseEvent) => {
        ev.preventDefault();
        console.log("next");

        _this.page++;
        _this.baseRender();
        try {
          // @ts-ignore
          window.posthog.capture("PDF Page Click", {
            direction: "next"
          });
        } catch (err) {
          console.log(err);
        }
      });

    if (this.page >= 1 && this.image !== "") {
      this.renderPdf(this.src);
    } else if (this.image === "") {
      this.renderPdf(this.src);
    }
  }
  /**
   * When attributes change they call
   */
  attributeChangedCallback(name: string, _oldValue: any, newValue: any) {
    console.log("attributeChangedCallback");
    if (name === DOCUMENT_FRAME_ATTRIBUTES.SRC && newValue != null) {
      // Invoke PDF.js when we have been given a path. We ignore `null` for
      // when the attribute is removed.
      this.renderPdf(newValue);
    }
  }

  ///////////////////////////

  async renderPdf(path: string) {
    await this.readyPromise;

    const pdfData = await fetch(path, {
      redirect: "follow"
    });

    const pdf = await pdfjs.getDocument({ data: await pdfData.arrayBuffer() })
      .promise;
    const page = await pdf.getPage(this.page);
    const viewport = page.getViewport({ scale: 1 });

    // We can simply query for the single `<canvas>` in our shadow DOM!
    const canvas = this.querySelector("canvas");
    if (!canvas) throw new Error("Canvas does not exist");

    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Context does not exist on canvas");

    console.log(viewport);
    console.log(page);

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderCtx = {
      canvasContext: ctx,
      viewport: viewport
    };

    console.log("rendering");
    page.render(renderCtx);
  }

  renderWithSrc(src: string) {
    const iframe = document.createElement("iframe");
    iframe.src = src;

    this.innerHTML = "";
    this.appendChild(iframe);
  }

  render() {
    if (this.isFacadeVisible) {
      // MOBILE ONLY
      this.innerHTML = `
      <div class="p-4 bg-neutral-200 cursor-pointer inline-block rounded-md">
        Click to activate PDF
      </div>
      `;

      this.addEventListener("click", () => {
        console.log("facade was clicked", this);
        this.isFacadeVisible = false;
        this.render();
      });

      // Add event listener
    } else if (this.filetype === "pdf") {
      console.log("pdfobject");
      // Rendering with PDFObject
      this.innerHTML = "";

      const container = document.createElement("div");
      container.style.height = "100%";
      container.style.width = "100%";

      const _this = this;

      import("pdfobject").then((PDFObject) => {
        PDFObject.embed(_this.src, container, {
          pdfOpenParams: {
            view: "Fit",
            scrollbars: "0",
            toolbar: "0",
            statusbar: "0",
            navpanes: "0"
          },
          supportRedirect: true,
          suppressConsole: false
        });

        _this.appendChild(container);
      });
    } else if (this.filetype !== "pdf") {
      this.renderWithSrc(
        `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          this.src
        )}`
      );
    } else {
      this.renderWithSrc(
        `https://docs.google.com/viewer?url=${encodeURIComponent(
          this.src
        )}&embedded=true`
      );
    }
  }
}
